import { eclipseTheme } from './generatedThemes/eclipseTheme';

export const defaultTheme = {
  ...eclipseTheme,
  variables: {
    animationDuration: {
      normal: '0.15s',
      long: '0.3s',
      extraLong: '1s',
    },
    opacity: {
      disabled: 0.5,
      low: 0.25,
      medium: 0.5,
      high: 0.75,
      hex: {
        100: '',
        75: 'bf',
        50: '80',
        25: '40',
        0: '00',
        disabled: '80',
      },
    },
    zIndex: {
      header: 1000,
      sidebar: 1010,
      modal: 1020,
      popover: 1030,
      notifications: 1040,
      blockUi: 1050,
    },
    dimensions: {
      limitedHeight: 500,
    },
  },
} as const;
